var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAstra = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 273 301",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Astra") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 164.5 136.1 99l18.2 42.1c12.1-5.2 24-9.7 35-13.1l-53-122.8-85.7 197.6a462.5 462.5 0 0 1 57.2-38.3ZM190.3 223.9l27.2 62.8h40.7L221 200.5a437.4 437.4 0 0 1-30.6 23.4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7 187.9c-24 15-45 31.2-60.9 47l-23 51.8h41.6l42.3-98.8Z",
    fill: "var(--color-brand-4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.4 141.7a335.2 335.2 0 0 0-35 13.1l23.8 55.1a357.3 357.3 0 0 0 30.4-23.8l-19.2-44.4Z",
    fill: "var(--color-brand-2)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAstra);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Astra.7e71776f049c554e38d4cca07327f4b3.svg";